import axios from 'axios';

// Create axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: 'https://pacificcrossquotes.com/api',   
  // baseURL: 'http://localhost:5555/api', // Your base URL
  headers: {
    'Accept': 'application/json, text/plain, */*',
  },
});

// Request interceptor to attach token
axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    // Check if the request is to a public API
    const isPublicApi = ['/login', '/forgot-password', '/reset-password', '/signup'].some(path => config.url.includes(path));

    if (token && !isPublicApi) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    // Simply return the response if it's successful
    return response;
  },
  (error) => {
    // Check if the error is due to an expired token
    if (error.response && error.response.status === 401) {
      // Remove token from localStorage
      localStorage.removeItem('token');
      // Redirect to the login page
      window.location.href = '/login'; // Adjust the URL as per your routing setup
    }
    // Return the error for further handling if needed
    return Promise.reject(error);
  }
);

export default axiosInstance;
